/** One colour per SRS rating, from the CEFR ramp so the hues already belong to the app. */
export const RATING_COLOR: Record<number, string> = {
  1: 'var(--color-cefr-c1-bg)',
  2: 'var(--color-cefr-b2-bg)',
  3: 'var(--color-cefr-a2-bg)',
  4: 'var(--color-cefr-a0-bg)',
}

export const RATING_LABEL: Record<number, string> = { 1: 'Again', 2: 'Hard', 3: 'Good', 4: 'Easy' }
